import React from 'react'
import { Image } from '@shared/components/image'
import { Section } from '@shared/components/section'
import History from '@shared/svg/history.svg'
import cx from 'classnames'

import { ProductsPageCard } from '../../../../data/products-pages'

import {
	productCardBorrowerRequirements,
	productCardImportant,
	productCardPaymentTypes,
	productCardPoints,
} from './data'

import styles from './style.module.scss'

export const View = ({
	title,
	subtitle,
	hint,
	documents,
	extraRequirements,
	extraRequirementsSection,
}: ProductsPageCard) => (
	<Section className={styles.wrapper}>
		<h2 className={styles.title}>{title}</h2>
		<div className={styles.conditions}>
			<div className={styles.subtitleWrap}>
				<h4>{subtitle}</h4>
				{hint && <span className={styles.hint}>{hint}</span>}
			</div>
			<div className={styles.points}>
				{productCardPoints.map(({ Icon, title }, i) => (
					<div className={styles.point} key={i}>
						<Icon className={styles.pointIcon} />
						<h5>{title}</h5>
					</div>
				))}
			</div>
		</div>
		<div className={styles.paymentTypesWrap}>
			<h3>Платежи</h3>
			<div className={styles.paymentTypes}>
				{productCardPaymentTypes.map(({ name, content, period }, i) => (
					<div className={styles.paymentType} key={`${i}_${name}`}>
						<h4>{name}</h4>
						<div className={styles.paymentTypeText}>
							{content} <br />
							<br />
							<span>Срок &mdash; {period}</span>
						</div>
					</div>
				))}
			</div>
		</div>
		{extraRequirementsSection && (
			<div className={styles.extraRequirementsWrapper}>
				<h3>{extraRequirementsSection.title}</h3>
				<div
					className={cx(styles.extraRequirements, {
						[styles.extraRequirementsOneColumn]: extraRequirementsSection.requirements.length === 1,
					})}
				>
					{extraRequirementsSection.requirements.map(({ points, name, description }, i) => (
						<div key={i + '_requirement'} className={styles.requirement}>
							{name && <h4>{name}</h4>}
							{description && <div className={styles.requirementDescription}>{description}</div>}
							<div className={styles.requirementContent}>
								{points.map((point, i) => (
									<h5 key={i} className={styles.requirementItem}>
										{point}
									</h5>
								))}
							</div>
						</div>
					))}
				</div>
			</div>
		)}
		<div className={styles.requirements}>
			<div className={styles.requirementsSummary}>
				<div className={styles.requirement}>
					<h3>Требования к заёмщику</h3>
					<div className={styles.requirementContent}>
						{productCardBorrowerRequirements.map((item, i) => (
							<div key={`${i}_${item}`} className={styles.requirementItem}>
								{item}
							</div>
						))}
					</div>
				</div>
				<div className={styles.requirement}>
					<h3>Документы</h3>
					<div className={cx(styles.requirementContent, styles.documents)}>
						{documents.map((item, i) => (
							<div key={`${i}_${item}`} className={styles.document}>
								<History className={styles.documentIcon} />
								{item}
							</div>
						))}
					</div>
				</div>
				{extraRequirements && (
					<div className={styles.requirement}>
						<h3>{extraRequirements.name}</h3>
						<div className={styles.requirementContent}>
							{extraRequirements.points.map((item, i) => (
								<h5 key={i} className={styles.requirementItem}>
									{item}
								</h5>
							))}
						</div>
					</div>
				)}
			</div>
			<div className={styles.important}>
				<h3>Важно</h3>
				<div className={styles.importantContent}>{productCardImportant}</div>
				{extraRequirements && (
					<div className={styles.importantImgWrapper}>
						<Image className={styles.importantImg} name='docs.png' lazy />
					</div>
				)}
			</div>
		</div>
	</Section>
)
